import { apiClient } from "../config";

async function deleteNotification(id: string) {
  const res = await apiClient.delete(`/admin/reminders/${id}`);
  return res.data;
}

export default deleteNotification;
